import { Project } from '@brg/api'
import { COVER_VIEWTYPES_1_9 } from 'shared/components/projectCard/stylesNew'
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes'
import { LMSCardFormatTypes } from 'shared/pages/teams/const/LMSCourseTypes'

export const TEAM_TAB_WIDE_GRID_VIEW_TYPES = [
  't-shape',
  'fixed-ratio-small',
  'fixed-ratio-large',
  'horizontal',
  'animated',
] as const

type TeamLikeProject = Project & {
  moderationType?: ModerationType
  lmsCover?: LMSCardFormatTypes
}

type LmsTeamLike = {
  moderationType?: ModerationType
  lmsCover?: LMSCardFormatTypes
}

const getLmsTeamFromProject = (project: Project): LmsTeamLike | null => {
  const projectAsTeam = project as TeamLikeProject
  if (projectAsTeam?.moderationType === ModerationType.LMS) {
    return projectAsTeam
  }

  const teams = (project as { teams?: LmsTeamLike[] }).teams
  const fromTeams = teams?.find((team) => team?.moderationType === ModerationType.LMS)
  if (fromTeams) {
    return fromTeams
  }

  const rootTeam = (project as { rootTeam?: LmsTeamLike }).rootTeam
  if (rootTeam?.moderationType === ModerationType.LMS) {
    return rootTeam
  }

  return null
}

const isLmsTeamWideCover = (team: LmsTeamLike): boolean => (
  team.lmsCover !== LMSCardFormatTypes.short
)

export type TeamTabProjectCoverLayoutOptions = {
  forceLmsWide?: boolean
}

export const getTeamTabProjectViewType = (project: Project): string | undefined => {
  return project?.projectType || (project as { longread?: { viewType?: string } })?.longread?.viewType
}

export const getTeamTabProjectGridColumnSpan = (project: Project): 1 | 2 => (
  isTeamTabProjectWideCover(project) ? 2 : 1
)

export const isTeamTabProjectWideCover = (
  project: Project,
  options?: TeamTabProjectCoverLayoutOptions,
): boolean => {
  const lmsTeam = getLmsTeamFromProject(project)
  if (lmsTeam) {
    if (options?.forceLmsWide) {
      return true
    }
    return isLmsTeamWideCover(lmsTeam)
  }

  const viewType = getTeamTabProjectViewType(project)
  if (!viewType) {
    return false
  }
  return (TEAM_TAB_WIDE_GRID_VIEW_TYPES as readonly string[]).includes(viewType)
}

export const isTeamTabProjectWideAspect = (project: Project): boolean => {
  const lmsTeam = getLmsTeamFromProject(project)
  if (lmsTeam) {
    return isLmsTeamWideCover(lmsTeam)
  }

  const viewType = getTeamTabProjectViewType(project)
  if (!viewType) {
    return false
  }
  return COVER_VIEWTYPES_1_9.includes(String(viewType))
}
import { Project } from '@brg/api'
import { COVER_VIEWTYPES_1_9 } from 'shared/components/projectCard/stylesNew'
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes'
import { LMSCardFormatTypes } from 'shared/pages/teams/const/LMSCourseTypes'

export const TEAM_TAB_WIDE_GRID_VIEW_TYPES = [
  't-shape',
  'fixed-ratio-small',
  'fixed-ratio-large',
  'horizontal',
  'animated',
] as const

type TeamLikeProject = Project & {
  moderationType?: ModerationType
  lmsCover?: LMSCardFormatTypes
}

type LmsTeamLike = {
  moderationType?: ModerationType
  lmsCover?: LMSCardFormatTypes
}

const getLmsTeamFromProject = (project: Project): LmsTeamLike | null => {
  const projectAsTeam = project as TeamLikeProject
  if (projectAsTeam?.moderationType === ModerationType.LMS) {
    return projectAsTeam
  }

  const teams = (project as { teams?: LmsTeamLike[] }).teams
  const fromTeams = teams?.find((team) => team?.moderationType === ModerationType.LMS)
  if (fromTeams) {
    return fromTeams
  }

  const rootTeam = (project as { rootTeam?: LmsTeamLike }).rootTeam
  if (rootTeam?.moderationType === ModerationType.LMS) {
    return rootTeam
  }

  return null
}

const isLmsTeamWideCover = (team: LmsTeamLike): boolean => (
  team.lmsCover !== LMSCardFormatTypes.short
)

export type TeamTabProjectCoverLayoutOptions = {
  forceLmsWide?: boolean
}

export const getTeamTabProjectViewType = (project: Project): string | undefined => {
  return project?.projectType || (project as { longread?: { viewType?: string } })?.longread?.viewType
}

export const getTeamTabProjectGridColumnSpan = (project: Project): 1 | 2 => (
  isTeamTabProjectWideCover(project) ? 2 : 1
)

export const isTeamTabProjectWideCover = (
  project: Project,
  options?: TeamTabProjectCoverLayoutOptions,
): boolean => {
  const lmsTeam = getLmsTeamFromProject(project)
  if (lmsTeam) {
    if (options?.forceLmsWide) {
      return true
    }
    return isLmsTeamWideCover(lmsTeam)
  }

  const viewType = getTeamTabProjectViewType(project)
  if (!viewType) {
    return false
  }
  return (TEAM_TAB_WIDE_GRID_VIEW_TYPES as readonly string[]).includes(viewType)
}

export const isTeamTabProjectWideAspect = (project: Project): boolean => {
  const lmsTeam = getLmsTeamFromProject(project)
  if (lmsTeam) {
    return isLmsTeamWideCover(lmsTeam)
  }

  const viewType = getTeamTabProjectViewType(project)
  if (!viewType) {
    return false
  }
  return COVER_VIEWTYPES_1_9.includes(String(viewType))
}
